import FallbackLoader from '@async-components/FallbackLoader';

export { keySeen } from './common';

export default FallbackLoader(() => import(/* webpackChunkName: "async-MandateBanner" */'./index'));
